var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5,
    height: 8,
    viewBox: "0 0 5 8",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.77714 3.49346C4.91984 3.62781 5 3.81002 5 4C5 4.18998 4.91984 4.37219 4.77714 4.50654L1.28102 7.79729C1.13922 7.92809 0.948305 8.00093 0.749766 7.99999C0.551227 7.99905 0.361106 7.92439 0.220716 7.79225C0.0803261 7.66011 0.00101237 7.48115 9.62432e-06 7.29428C-0.000993122 7.1074 0.0763962 6.9277 0.215361 6.79423L3.18398 4L0.215361 1.20577C0.0763962 1.0723 -0.000993122 0.892599 9.62432e-06 0.705723C0.00101237 0.518847 0.0803261 0.339893 0.220716 0.20775C0.361106 0.0756075 0.551227 0.000952901 0.749766 9.05896e-06C0.948305 -0.000934783 1.13922 0.0719085 1.28102 0.20271L4.77714 3.49346Z",
    fill: "#0044CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.f9c50d79e4ee35a3ae81230ffab6b4f9.svg";
export { ForwardRef as ReactComponent };